export type MotivoFallaDestino = 'cierre' | 'replanificacion';

// SMP-395: 8vo motivo, sumado al listado fijo de SMP-179 con destino "replanificacion" (vuelve a
// Pendiente). Se expone como constante porque ademas de este mapeo, Detail.tsx necesita
// identificar este motivo puntual para habilitar la edicion del lugar de ocurrencia.
export const ID_MOTIVO_LUGAR_OCURRENCIA_ERRONEO = 8;

// SMP-179: la HU define un listado fijo de motivos de falla con su destino (agregar, quitar o
// editar motivos queda fuera de su alcance, salvo la incorporacion puntual de SMP-395). Se mapea
// por id del catalogo real de GET /visitas/motivos-falla (mas seguro que comparar por
// descripcion, que podria cambiar de texto sin que cambie su significado).
const IDS_MOTIVO_REPLANIFICACION = new Set([
    2, // Direccion inaccesible
    4, // No atiende nadie
    5, // Establecimiento sin personal / sin actividad
    6, // No permite el ingreso / no brinda informacion
    ID_MOTIVO_LUGAR_OCURRENCIA_ERRONEO // Lugar de ocurrencia erroneo (siniestros) - SMP-395
]);

const IDS_MOTIVO_CIERRE = new Set([
    1, // Direccion inexistente
    3, // Desconocido / Se mudo
    7 // Obra finalizada
]);

export const getMotivoFallaDestino = (idMotivoFalla?: number | null): MotivoFallaDestino => {
    // Sin motivo seleccionado todavia (formulario recien abierto, visita no fallida): estado
    // normal, no una anomalia, no amerita warning.
    if (idMotivoFalla == null) {
        return 'cierre';
    }

    if (IDS_MOTIVO_REPLANIFICACION.has(idMotivoFalla)) {
        return 'replanificacion';
    }

    if (IDS_MOTIVO_CIERRE.has(idMotivoFalla)) {
        return 'cierre';
    }

    // Motivo fuera del listado conocido: agregar/editar motivos esta fuera del alcance de la HU,
    // asi que esto solo deberia pasar si el catalogo cambio sin actualizar este mapeo. No se
    // asume "cierre" por descarte silencioso: se deja constancia para que no pase desapercibido.
    console.warn(
        `getMotivoFallaDestino: id de motivo de falla desconocido (${idMotivoFalla}), se usa "cierre" por default.`
    );
    return 'cierre';
};
